<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <div class="row">
          <div class="col-sm-6">
            <h3>{{$t("app")}}</h3>
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="index.html">{{$t("management")}}</a></li>
              <li class="breadcrumb-item active">{{$t("app_management")}}</li>
            </ol>
          </div>
          <div class="col-sm-6">
            <!-- Bookmark Start-->
            <div class="bookmark">
              <ul>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Tables"><i data-feather="inbox"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Chat"><i data-feather="message-square"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Icons"><i data-feather="command"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Learning"><i data-feather="layers"></i></a></li>
                <li><a href="javascript:void(0)"><i class="bookmark-search" data-feather="star"></i></a>
                  <form class="form-inline search-form">
                    <div class="form-group form-control-search">
                      <input type="text" :placeholder="$t('search') + '...'">
                    </div>
                  </form>
                </li>
              </ul>
            </div>
            <!-- Bookmark Ends-->
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-9">
          <div class="card">
            <div class="card-header pb-0">
              <h5 v-if="editMode">{{$t("edit_app")}}</h5>
              <h5 v-else>{{$t("create_app")}}</h5>
            </div>
            <div class="card-body">
              <div class="form theme-form">
                <div class="row">
                  <div class="col">
                    <div class="mb-3">
                      <label>{{$t("designation")}}*</label>
                      <input class="form-control" type="text" v-model="app.name">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="mb-3">
                      <label>{{$t("packagename")}}*</label>
                      <input class="form-control" type="text" v-model="app.packageName">
                    </div>
                  </div>
                  <div class="col">
                    <div class="mb-3">
                      <label>{{$t("playStoreUrl")}}*</label>
                      <input class="form-control" type="text" v-model="app.playStoreUrl">
                    </div>
                  </div>
                  <div class="col">
                    <div class="mb-3">
                      <label>{{$t("appStoreUrl")}}*</label>
                      <input class="form-control" type="text" v-model="app.appStoreUrl">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="mb-3">
                      <label>{{$t("baseurl")}}*</label>
                      <input class="form-control" type="text" v-model="app.baseUrl">
                    </div>
                  </div>
                  <div class="col">
                    <div class="mb-3">
                      <label>{{$t("apikey")}}</label>
                      <input class="form-control" type="text" v-model="app.xApiKey">
                    </div>
                  </div>
                  <div class="col">
                    <div class="mb-3">
                      <label>{{$t("imageprefixurl")}}</label>
                      <input class="form-control" type="text" v-model="app.imagePrefixUrl">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col py-0">
                    <div class="mb-3">
                      <label>{{$t("description")}}*</label>
                      <v-textarea class="datainput justify-content-end align-self-center pb-1" dense outlined
                          hide-details="auto" v-model="app.description"></v-textarea>
                    </div>
                  </div>
                  <div class="col py-0">
                    <div class="mb-3">
                      <label>{{$t("icon")}}*</label>
                      <Upload :label="''" v-model="app.icon" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col py-0">
                    <div class="mb-3">
                      <label>{{$t("target_audience_configuration")}}*</label>
                      <v-textarea class="datainput justify-content-end align-self-center pb-1" dense outlined
                          hide-details="auto" v-model="app.targetAudienceConfiguration"></v-textarea>
                    </div>
                  </div>
                </div>
                <button style="float: right;" @click="save()" class="btn btn-primary" type="button"
                  data-bs-original-title="" title="">{{$t("save")}}</button>
                  <button class="btn btn-secondary mr-2" style="float: right;" @click="$routerBack()">{{$t("cancel")}}</button>
              </div>
            </div>
          </div>

        </div>

        <div class="col-3">
          <div class="card">
            <div class="card-header pb-0">
              <h5>{{$t("actions")}}</h5>
            </div>
            <div class="card-body" v-if="editMode">
              <button @click="showDeleteConfirmation = true" class="btn btn-danger" type="button"
                data-bs-original-title="" title="">{{$t("delete_app")}}</button>
            </div>
            <div class="card-body" v-else>
              <p>{{$t("APP_SAVE_BEFORE_DELETE_HINT")}}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- Container-fluid Ends-->

      <div class="modal fade show" v-show="showDeleteConfirmation" tabindex="-1" aria-labelledby="exampleModalCenter" style="display: block; padding-right: 17px; background: rgba(0,0,0,.5);" aria-modal="true" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t("delete_app")}}</h5>
            <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close" data-bs-original-title="" title="" @click="(showDeleteConfirmation = false)"></button>
          </div>
          <div class="modal-body">
            <p>{{$t("confirm_delete_app")}}</p>
          </div>
          <div class="modal-footer">
            <button @click="(showDeleteConfirmation = false)" class="btn btn-secondary" type="button" data-bs-dismiss="modal" data-bs-original-title="" title="">{{$t("cancel")}}</button>
            <button @click="deleteApp()" class="btn btn-danger" type="button" data-bs-original-title="" title="">{{$t("delete")}}</button>
          </div>
        </div>
      </div>
    </div>

    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { MapPinIcon, PlusSquareIcon } from 'vue-feather-icons'

export default {

  props: {
    appId: Number,
  },

  components: {
    apexcharts: VueApexCharts,
    MapPinIcon,
    PlusSquareIcon,
  },
  data() {
    return {
      editMode: false,

      app: {
        name: "",
        packageName: "",
        icon: "",
        description: "",
        targetAudienceConfiguration: "",
        playStoreUrl: "",
        appStoreUrl: "",
        baseUrl: "",
        xApiKey: "",
      },

      tenants: [],
      showDeleteConfirmation: false,

      map: {
        center: {
          latitude: 52.218945,
          longitude: 13.439067
        },
        zoom: 10,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      },

      boundaries: [],
    };
  },

  mounted() {
    if (this.appId != null) {
      this.editMode = true;
      this.fetchEditingApp();
    } else {
      // this.fetchApps();
    }
  },

  methods: {
    _validate(){
      
      if(this.app.name == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("designation") }));
        return false;
      }
      if(this.app.packageName == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("packageName") }));
        return false;
      }
      if(this.app.icon == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("icon") }));
        return false;
      }
      if(this.app.description == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("description") }));
        return false;
      }
      if(this.app.targetAudienceConfiguration == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("target_audience_configuration") }));
        return false;
      }
      if(this.app.playStoreUrl == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("playStoreUrl") }));
        return false;
      }
      if(this.app.appStoreUrl == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("appStoreUrl") }));
        return false;
      }
      if(this.app.baseUrl == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("baseurl") }));
        return false;
      }
      console.log(this.app);
      return true;
    },
    fetchEditingApp() {
      var _this = this;
      this.$axios
        .get("/api/app/" + this.appId)
        .then(function (response) {
          _this.app = response.data;
        })
        .catch(this.onError);
    },
    // fetchApps(search = ""){
    //   if(search == null) return;
    //   var _this = this;
    //   progressIndicator.hidden = false;
    //   this.$axios
    //     .get("/api/app?size=50&search=" + search)
    //     .then(function (response) {
    //       if(_this.tenants.length == 0) _this.tenants = response.data.content;
    //       for (let i = 0; i < response.data.content.length; i++) {
    //         const tenant = response.data.content[i];
    //         if(_this.tenants.filter(t => { return t.name == tenant.name }).length == 0){
    //           _this.tenants.push(tenant);
    //         }
    //       }

    //       if(_this.tenantId != null){
    //         // Remove Tenant which is being edited (no self-adding)
    //         for (let i = _this.tenants.length - 1; i >= 0; i--) {
    //           const tenant = _this.tenants[i];
    //           if(tenant.id == _this.tenantId){
    //             _this.tenants.splice(i, 1);
    //           }
    //         }
    //       }
    //       _this.$forceUpdate();
    //     })
    //     .catch(this.onError)
    //     .finally(this.finalize);
    // },
    save() {
      if(!this._validate()) return;
      var app = Object.assign({}, this.app);
      if (this.editMode) {
        this.updateApp(app);
      } else {
        this.createApp(app);
      }
    },
    createApp(app) {
      var _this = this;
      this.$axios
        .post("/api/app", app)
        .then(function (response) {
          _this.$noty.success(_this.$t("app_created"));
          _this.$router.push("/apps");
        })
        .catch(this.onError);
    },
    updateApp(app) {
      var _this = this;
      this.$axios
        .put("/api/app/" + this.appId, app)
        .then(function (response) {
          _this.$noty.success(_this.$t("app_edited"));
          _this.$router.push("/apps");
        })
        .catch(this.onError);
    },
    deleteApp(){
      var _this = this;
      this.$axios
        .delete("/api/app/" + this.appId)
        .then(function (response) {
          _this.showDeleteConfirmation = false;
          _this.$noty.success(_this.$t("app_deleted"));
          _this.$router.push("/apps");
        })
        .catch(this.onError);
    },
    logError(error) {
      console.log(error);
    },
    onError(error) {
      console.log(error);
    },
    finalize() {
      progressIndicator.hidden = true;
    }
  },
};
</script>

<style>

</style>